import HashRoute from './HashRoute';
import withHashRoutePortal from './withHashRoutePortal';

export default HashRoute;

export { withHashRoutePortal };
